function importAll(r) {
    return r.keys().map(r);
}

const allMedia = importAll(require.context('./media/equipment', true, /\.(png|jpe?g|webp)$/));

const equipmentNames = [`Sauce pan`, `Medium pot`, `Mortar & pestle (optional)`]

export let equipment = equipmentNames.map((item, index) => {
    return {img: allMedia[index], name: item}
})